<template>
  <v-dialog 
  v-model="dialog" 
  content-class="c-dialog-border-13"
  scrollable 
  persistent 
  transition="c-anim-slide-left-fade"
  :fullscreen="$vuetify.breakpoint.xs" 
  max-width="400px">

    <v-card v-if="dialog">

      <v-layout class="c-flex-00a pa-4 crx-toolbar subheading">
        <div class="c-flex-r1 align-center text-sans font-weight-bold">
          Edit quantity
        </div>
      </v-layout>
    
      <!-- DIALOG MAIN CONTENT -->
      <div style="overflow: auto;" class="pl-3 pr-3 pt-3">
        <edit-inv-form :invID="id" @onClose="close" @onUpdate="$emit('onUpdate')"></edit-inv-form>
      </div><!-- END DIALOG MAIN CONTENT -->
    </v-card>

  </v-dialog>
</template>

<script>
import EditInvForm from './edit-inv-quantity'
export default {
  components: {
    EditInvForm
  },
  data () {
    return {
      id: null,
      dialog: false
    }
  },
  methods: {
    open (id) {
      this.id = id
      this.dialog = true
    },
    close () {
      this.dialog = false
    }
  }
  
}
</script>
